<template>
    <section class="question">
        <div class="question__animation" v-if="animation">
            <img v-if="typeof animation === 'string'" :src="animation" alt="">
            <lottie-player
                v-else
                ref="lottie"
                class="question__player"
                background="transparent"
                speed="1"
                loop
                autoplay></lottie-player>
        </div>
        <div class="question__content" :class="{'question__content--no-col': !animation}">
            <div class="frequency-input">
                <p class="supertitle" v-if="questionNumber">otázka {{ questionNumber }}</p>
                <h2 class="title" v-if="title">{{ title }}</h2>
                <div class="frequency-input__inner" :class="{'frequency-input__inner--align-left': animation, 'frequency-input__inner--w100': embeded}">
                    <button
                        class="frequency-input__btn frequency-input__btn--minus"
                        @click="valueDown"
                        :disabled="value === 0">–</button>
                    <input type="number" class="frequency-input__input" v-model="value" min="0">
                    <button class="frequency-input__btn frequency-input__btn--mr" @click="valueUp">+</button>
                    <span class="frequency-input__text">{{ unit }}</span>
                    <button
                        class="frequency-input__btn frequency-input__btn--minus"
                        :disabled="frequency === 0"
                        @click="frequencyDown">–</button>
                    <span class="frequency-input__frequency">{{ frequencies[frequency].text }}</span>
                    <button
                        class="frequency-input__btn"
                        :disabled="frequency === (frequencies.length - 1)"
                        @click="frequencyUp">+</button>
                </div>
            </div>
            <slot></slot>
        </div>
    </section>
</template>

<script>
import animation from "@/mixins/animation";

export default {
    name: "GroheFrequency",
    mixins: [animation],
    props: {
        title: {
            type: String,
            required: false
        },
        unit: {
            type: String,
            required: true
        },
        valuePerUnit: {
            type: Number,
            required: true
        },
        name: {
            type: String,
            required: false
        },
        questionNumber: {
            type: String
        },
        embeded: {
            type: Boolean,
            default: false,
        }
    },
    data: () => ({
        value: 0,
        frequency: 1,
        frequencies: [
            {
                value: 1,
                text: 'denně'
            },
            {
                value: 7,
                text: 'týdně'
            },
            {
                value: 30,
                text: 'měsíčně'
            }
        ]
    }),
    computed: {
        consumption() {
            let value = this.value;
            if (this.frequency) value = value / this.frequencies[this.frequency].value;
            return parseFloat((value * this.valuePerUnit).toFixed(2));
        }
    },
    methods: {
        frequencyDown() {
            this.frequency--
        },
        frequencyUp() {
            this.frequency++
        },
        valueDown() {
            if (this.value === 0) return
            this.value--
        },
        valueUp() {
            this.value++
        },
        validate() {
            this.$emit('on-validate', true, this.name, this.consumption);
            return true;
        }
    },
    watch: {
        value(newVal) {
            if (newVal < 0) this.value = 0;
        }
    }
}
</script>

<style lang="scss">
.frequency-input {

    &__inner {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding: 0 15px;
        height: 60px;
        border: 2px solid $crow-black-blue;
        border-radius: 100px;
        background-color: $calcareous-sinter;
        &--w100 {
            width: calc(100% + 4px);
            border-top-left-radius: 0;
            border-top-right-radius: 0;
            border-bottom-right-radius: 18px;
            border-bottom-left-radius: 18px;
            z-index: 1;
        }
    }
    &__input {
        width: 35px;
        border: none;
        background: transparent;
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        color: $crow-black-blue;
    }
    &__btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        padding: 0;
        border: 2px solid #0F2B4B;
        border-radius: 50%;
        background-color: transparent;
        color: #0F2B4B;
        font-weight: 600;
        font-size: 20px;
        cursor: pointer;
        outline: none;
        transition: background-color .2s;

        &--minus {
            padding-bottom: 3px;
            font-family: monospace;
        }
        &--mr {
            margin-right: 15px;
        }
        &:disabled {
            opacity: .5;
            cursor: default;
        }
        &:hover:not(:disabled) {
            background-color: $crow-black-blue;
            color: white;
        }
    }
    &__text,
    &__frequency {
        padding: 0 10px;
        font-size: 14px;
        font-weight: 600;
    }
    &__frequency {
        width: 86px;
        text-align: center;
        text-transform: uppercase;
    }
    &__text {
        display: none;
        padding: 0 20px;

        &:empty {
            padding: 0 15px;
        }
    }

    @media screen and (min-width: 450px) {
        &__text {
            display: block;
        }
        &__text,
        &__frequency {
            font-size: 16px;
        }
        &__inner {
            padding: 0 25px;
        }
        &__input {
            width: 40px;
            font-size: 16px;
        }
        &__frequency {
            width: 104px;
        }
        &__btn {
            &--mr {
                margin-right: 0;
            }
        }
    }

    @media screen and (min-width: $mq-md) {
        &__inner {
            &--align-left {
                justify-content: flex-start;
            }
            &--w100 {
                width: auto;
                border-radius: 100px
            }
        }
    }
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type=number] {
    -moz-appearance: textfield;
}
</style>
